// Import dependencies
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import initialiser from '../../utils/initialiser';

gsap.registerPlugin(ScrollTrigger);

class PageScrollAnimation {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.element = el;
    this.eleAnimated = settings.eleAnimated;
    this.eleRevealFromRight = [...el.querySelectorAll(settings.eleRevealFromRight)];
    this.mediaQuery = window.matchMedia(`(min-width: ${settings.mediaQuery}px)`).matches;

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function
  init = () => {
    if (!this.element) return;

    if (window.location.hash && !['#calendar', '#whatson'].includes(window.location.hash)) {
      setTimeout(() => {
        document.querySelector(window.location.hash).scrollIntoView({
          behavior: 'smooth',
        });
      }, 1250);
    } else {
      this.animateElementsWhenInView();
      if (this.mediaQuery) this.revealElementsFromRight();
    }
  };

  animateOnScroll = (ele, x, y, duration = 0.7, ease = 'power1.inOut') => {
    gsap.fromTo(
      ele,
      { x, y, opacity: 0 },
      {
        x: 0,
        y: 0,
        duration,
        ease,
        opacity: 1,
        scrollTrigger: {
          trigger: ele,
          toggleClass: this.eleAnimated,
        },
      },
    );
  };

  animateElementsWhenInView = () => {
    this.animateOnScroll(this.element, 0, 50);
  };

  revealElementsFromRight = () => {
    this.eleRevealFromRight.forEach((ele) => {
      this.animateOnScroll(ele, 100, 0);
    });
  };
}

export default (settings) => initialiser(settings, PageScrollAnimation);
